/* eslint-disable max-len */
import 'react';

const SidebarAddSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
        <g id="加号" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M10.1,4.25 C10.3761424,4.25 10.6,4.47385763 10.6,4.75 L10.599,9.472 L15.25,9.47222222 C15.5261424,9.47222222 15.75,9.69607985 15.75,9.97222222 C15.75,10.2483646 15.5261424,10.4722222 15.25,10.4722222 L10.599,10.472 L10.6,15.25 C10.6,15.5261424 10.3761424,15.75 10.1,15.75 C9.82385763,15.75 9.6,15.5261424 9.6,15.25 L9.599,10.472 L4.75,10.4722222 C4.47385763,10.4722222 4.25,10.2483646 4.25,9.97222222 C4.25,9.69607985 4.47385763,9.47222222 4.75,9.47222222 L9.599,9.472 L9.6,4.75 C9.6,4.47385763 9.82385763,4.25 10.1,4.25 Z" id="形状结合" fill="#5C6473" />
        </g>
    </svg>
);
export default SidebarAddSvg;
